import { defineMessages } from 'react-intl'

export default defineMessages({
  createSchedulingPoll: {
    id: 'containers.SchedulingPollCreatePage.createSchedulingPoll',
    defaultMessage: 'Create Scheduling Poll',
  },
  creatingForOrder: {
    id: 'containers.SchedulingPollCreatePage.creatingForOrder',
    defaultMessage: 'Creating scheduling poll for Order: {orderName}',
  },
  availabilityFor: {
    id: 'containers.SchedulingPollCreatePage.availabilityFor',
    defaultMessage: 'Availability for Order: {orderName}',
  },
  loadOrderError: {
    id: 'containers.SchedulingPollCreatePage.loadOrderError',
    defaultMessage: 'Failed to load order details',
  },
  createPoll: {
    id: 'containers.SchedulingPollCreatePage.createPoll',
    defaultMessage: 'Create Scheduling Poll',
  },
  creating: {
    id: 'containers.SchedulingPollCreatePage.creating',
    defaultMessage: 'Creating...',
  },
  pollCreated: {
    id: 'containers.SchedulingPollCreatePage.pollCreated',
    defaultMessage: 'Scheduling Poll Created!',
  },
  shareLink: {
    id: 'containers.SchedulingPollCreatePage.shareLink',
    defaultMessage: 'Share this link with participants to collect their availability:',
  },
  copyLink: {
    id: 'containers.SchedulingPollCreatePage.copyLink',
    defaultMessage: 'Copy Link',
  },
  createAnother: {
    id: 'containers.SchedulingPollCreatePage.createAnother',
    defaultMessage: 'Create Another',
  },
  viewDetails: {
    id: 'containers.SchedulingPollCreatePage.viewDetails',
    defaultMessage: 'View Details',
  },
  viewAllPolls: {
    id: 'containers.SchedulingPollCreatePage.viewAllPolls',
    defaultMessage: 'View All Polls',
  },
  pollCreatedSuccess: {
    id: 'containers.SchedulingPollCreatePage.pollCreatedSuccess',
    defaultMessage: 'Scheduling poll created successfully!',
  },
  createPollError: {
    id: 'containers.SchedulingPollCreatePage.createPollError',
    defaultMessage: 'Failed to create scheduling poll',
  },
  linkCopied: {
    id: 'containers.SchedulingPollCreatePage.linkCopied',
    defaultMessage: 'Link copied to clipboard!',
  },
  linkCopyFailed: {
    id: 'containers.SchedulingPollCreatePage.linkCopyFailed',
    defaultMessage: 'Failed to copy link',
  },
})
